const RecordPageComponent = {
    data() {
        return {
            loading: false,
            step: 0,
            lockMinStep: 0,

            professions: [],
            doctors: [],
            services: [],

            scheduleDays: [],
            scheduleSlots: {},

            selected: {
                profession_id: 0,
                user_id: 0,
                service_id: 0,
                store_id: 0,
                date: '',
                time: '',
                duration_min: 60,
                price: 0,
            },

            form: {
                last_name: '',
                first_name: '',
                patronymic: '',
                birthday: '',
                phone: '',
                email: '',
                agree: false,
            },
            dateSwiper: null,
            timeSwiper: null,
        };
    },

    methods: {
        async loadProfessions() {
            const resp = await window.recordPageService.getProfessions();
            this.professions = resp?.data?.list ?? [];
        },

        async loadDoctors() {
            const resp = await window.recordPageService.getDoctors(this.selected.profession_id);
            this.doctors = resp?.data?.list ?? [];
        },

        async loadServices() {
            const resp = await window.recordPageService.getServices(this.selected.profession_id, this.selected.user_id);
            this.services = resp?.data?.list ?? [];
        },

        async loadSchedule() {
            const today = new Date().toISOString().slice(0, 10);
            const resp = await window.recordPageService.getSchedule(this.selected.user_id, today, 14, this.selected.store_id);
            this.scheduleDays = resp?.data?.days ?? [];
            this.scheduleSlots = resp?.data?.slots ?? {};
        },

        async loadDoctorStores() {
            const resp = await window.recordPageService.getDoctorStores(this.selected.user_id);
            const list = resp?.data?.list ?? [];

            // сохраняем первый филиал как текущий
            const first = list[0] ?? null;

            this.selected.store_id = Number(first?.id || 0);

            // чтобы в подтверждении было что показать
            this.selected.store_title = String(first?.title || '');
            this.selected.store_address = String(first?.address || '');
        },

        setStep(stepIndex) {
            const next = Math.max(this.lockMinStep, Number(stepIndex) || 0)
            this.step = next
            this.renderStep()
            if (this.step === 4) this.renderConfirmation()
        },

        renderStep() {
            const root = document.getElementById('recordForm');
            if (!root) return;

            const states = root.querySelectorAll('.calculate__states .state');
            states.forEach((el, idx) => el.classList.toggle('current', idx === this.step));

            const head = root.querySelectorAll('.states__head li');
            head.forEach((el, idx) => el.classList.toggle('current', idx === this.step));

            if (root) {
                root.querySelectorAll('.prev-state').forEach(btn => {
                    const disabled = (this.step <= this.lockMinStep)
                    btn.disabled = disabled
                    btn.classList.toggle('disabled', disabled)
                    btn.style.pointerEvents = disabled ? 'none' : ''
                    btn.style.opacity = disabled ? '0.4' : ''
                })
            }

            this.syncButtons();
        },

        syncButtons() {
            const root = document.getElementById('recordForm');
            if (!root) return;

            const state = root.querySelectorAll('.calculate__states .state')[this.step];
            const nextBtn = state?.querySelector('.next-state');
            if (!nextBtn) return;

            const ok =
                (this.step === 0 && !!this.selected.profession_id) ||
                (this.step === 1 && !!this.selected.user_id) ||
                (this.step === 2 && !!this.selected.service_id) ||
                (this.step === 3 && !!this.selected.date && !!this.selected.time) ||
                (this.step === 4 && !!this.form.last_name && !!this.form.first_name && !!this.form.phone && this.form.agree === true);

            nextBtn.disabled = !ok;
        },

        renderProfessionsList() {
            const ul = document.getElementById('recordForm')?.querySelector('.speciality__list');
            if (!ul) return;

            ul.innerHTML = '';

            for (const p of this.professions) {
                const id = Number(p.id || 0);
                const title = String(p.title || '');

                const li = document.createElement('li');
                li.innerHTML = `
                        <label class="checkbox-container required">
                            <input type="radio" name="speciality-name" value="${id}">
                            <p><span class="checkmark"></span>${title}</p>
                        </label>
                    `;

                li.querySelector('input').addEventListener('change', async () => {
                    this.selected.profession_id = id;
                    this.selected.user_id = 0;
                    this.selected.service_id = 0;
                    this.selected.date = '';
                    this.selected.time = '';

                    await this.loadDoctors();
                    this.renderDoctorsList();
                    this.syncButtons();
                });

                ul.appendChild(li);
            }
        },

        renderDoctorsList() {
            const wrap = document.getElementById('recordForm')?.querySelector('.doctors-items');
            if (!wrap) return;

            wrap.innerHTML = '';

            for (const d of this.doctors) {
                const id = Number(d.id || 0);
                const fio = String(d.fio || '');
                const photo = (d.photo || d.avatar)
                    ? (window.appConfig.baseUrl + (d.photo || d.avatar))
                    : '/img/plug.jpg';

                const label = document.createElement('label');
                label.className = 'noneactive';
                label.innerHTML = `
                        <input type="radio" name="doctor-name" value="${id}">
                        <div class="radio-name">
                            <div class="team-slide">
                                <div class="team-slide__img"><img src="${photo}" alt=""></div>
                                <div class="team-slide__info"><p class="team-slide__name">${fio}</p></div>
                            </div>
                        </div>
                    `;

                label.querySelector('input').addEventListener('change', async () => {
                    this.selected.user_id = id;
                    this.selected.store_id = 0;
                    this.selected.service_id = 0;
                    this.selected.date = '';
                    this.selected.time = '';
                    await this.loadDoctorStores();
                    await this.loadServices();
                    this.renderServicesList();
                    this.syncButtons();
                });

                wrap.appendChild(label);
            }
        },

        renderServicesList() {
            const ul = document.getElementById('recordForm')?.querySelector('.services-wrap__list');
            if (!ul) return;

            ul.innerHTML = '';

            for (const s of this.services) {
                const id = Number(s.id || 0);
                const title = String(s.title || '');
                const price = Number(s.price || 0);
                const duration = Number(s.duration_min || 60);

                const li = document.createElement('li');
                li.innerHTML = `
                        <label class="checkbox-container required">
                            <input type="radio" name="services-name" value="${id}">
                            <p><span class="checkmark"></span>${title} <span class="service-price">(${this.formatPriceRub(price)})</span> </p> 
                        </label>
                    `;

                li.querySelector('input').addEventListener('change', async () => {
                    this.selected.service_id = id;
                    this.selected.price = price;
                    this.selected.duration_min = duration;
                    this.selected.date = '';
                    this.selected.time = '';

                    await this.loadSchedule();
                    this.renderSchedule();
                    this.syncButtons();
                });

                ul.appendChild(li);
            }
        },

        renderSchedule() {
            const root = document.getElementById('recordForm');
            const dateWrapper = root?.querySelector('.date-slider .swiper-wrapper');
            const timeWrapper = root?.querySelector('.time-slider .swiper-wrapper');
            if (!dateWrapper || !timeWrapper) return;

            dateWrapper.innerHTML = '';
            timeWrapper.innerHTML = '';

            // 1) Создаем по слайду на каждый день: и для дат, и для времени
            this.scheduleDays.forEach((d, idx) => {
                const date = String(d.date || '');
                const title = this.formatDateRu(date);
                const disabled = !!d.disabled;

                // --- DATE SLIDE ---
                const dateSlide = document.createElement('div');
                dateSlide.className = 'swiper-slide';
                dateSlide.innerHTML = `
      <div class="date-slide ${disabled ? 'date-slide--disabled' : ''}" data-date="${date}" data-idx="${idx}">
        <p>${title}</p>
      </div>
    `;
                dateWrapper.appendChild(dateSlide);

                // --- TIME SLIDE (с тем же idx) ---
                const timeSlide = document.createElement('div');
                timeSlide.className = 'swiper-slide';

                // слоты именно этого дня
                const slots = (this.scheduleSlots?.[date] || []);
                if (!disabled && slots.length) {
                    const ul = document.createElement('ul');

                    slots.forEach((t) => {
                        const li = document.createElement('li');
                        li.innerHTML = `
          <label class="noneactive">
            <input type="radio" name="time" value="${t}">
            <div class="radio-name">${t}</div>
          </label>
        `;

                        li.querySelector('input').addEventListener('change', () => {
                            // ВАЖНО: выбор времени всегда привязывает дату текущего слайда
                            this.selected.date = date;
                            this.selected.time = String(t);

                            this.syncButtons();
                        });

                        ul.appendChild(li);
                    });

                    timeSlide.appendChild(ul);
                } else {
                    // оставляем пустой слайд, как в твоем “красивом” шаблоне
                    timeSlide.innerHTML = '';
                }

                timeWrapper.appendChild(timeSlide);

                // 2) Клик по дате — прокручиваем dateSwiper (timeSwiper подтянется синхронно)
                const dateEl = dateSlide.querySelector('.date-slide');
                if (!disabled) {
                    dateEl.addEventListener('click', () => {
                        // сдвигаем слайдер на нужный индекс
                        this.dateSwiper?.slideTo(idx);

                        // подсветка + установка выбранной даты
                        this.setActiveDateByIndex(idx);
                    });
                }
            });

            // 3) Инициализация/переинициализация СВАЙПЕРОВ после отрисовки
            requestAnimationFrame(() => {
                this.reinitSwipers();
                // выставим активным первый доступный день
                const firstIdx = this.scheduleDays.findIndex(x => !x.disabled);
                if (firstIdx >= 0) {
                    this.dateSwiper?.slideTo(firstIdx, 0);
                    this.setActiveDateByIndex(firstIdx);
                }
            });
        },

        setActiveDateByIndex(idx) {
            const root = document.getElementById('recordForm');
            if (!root) return;

            const day = this.scheduleDays[idx];
            if (!day || day.disabled) return;

            const date = String(day.date || '');

            // если дата меняется — сбрасываем время
            if (this.selected.date !== date) {
                this.selected.time = '';
            }

            this.selected.date = date;

            // подсветка “active” на кнопках дат
            root.querySelectorAll('.date-slide').forEach(x => x.classList.remove('active'));
            const active = root.querySelector(`.date-slide[data-idx="${idx}"]`);
            if (active) active.classList.add('active');

            // сброс выбранного radio времени (чтобы не оставалось старое выделение)
            root.querySelectorAll('.time-slider input[name="time"]').forEach(inp => inp.checked = false);

            this.syncButtons();
        },

        reinitSwipers() {
            const root = document.getElementById('recordForm');
            if (!root || !window.Swiper) return;

            const dateEl = root.querySelector('.date-slider');
            const timeEl = root.querySelector('.time-slider');
            if (!dateEl || !timeEl) return;

            // убиваем старые
            if (this.dateSwiper) {
                this.dateSwiper.destroy(true, true);
                this.dateSwiper = null;
            }
            if (this.timeSwiper) {
                this.timeSwiper.destroy(true, true);
                this.timeSwiper = null;
            }

            const nextEl = root.querySelector('.date-slider-wrap .swiper-button-next');
            const prevEl = root.querySelector('.date-slider-wrap .swiper-button-prev');

            const commonBreakpoints = {
                0: {slidesPerView: 1.2},
                480: {slidesPerView: 2.2},
                768: {slidesPerView: 3.2},
                1024: {slidesPerView: 5},
            };

            // DATE
            this.dateSwiper = new window.Swiper(dateEl, {
                slidesPerView: 5,
                spaceBetween: 10,
                navigation: {nextEl, prevEl},
                watchOverflow: true,
                observer: true,
                observeParents: true,
                breakpoints: commonBreakpoints,
                on: {
                    slideChange: () => {
                        const idx = this.dateSwiper.activeIndex || 0;
                        // timeSwiper держим в том же индексе
                        this.timeSwiper?.slideTo(idx);
                        this.setActiveDateByIndex(idx);
                    },
                },
            });

            // TIME (ВАЖНО: тот же slidesPerView, чтобы колонки совпадали)
            this.timeSwiper = new window.Swiper(timeEl, {
                slidesPerView: 5,
                spaceBetween: 10,
                allowTouchMove: false, // обычно время не свайпают отдельно
                watchOverflow: true,
                observer: true,
                observeParents: true,
                breakpoints: commonBreakpoints,
            });

            // стартовая синхронизация
            this.timeSwiper.slideTo(this.dateSwiper.activeIndex || 0, 0);
        },

        formatDateRu(dateStr) {
            // "2026-02-10" -> "10 февраля, вт"
            if (!dateStr) return '—';

            const d = new Date(dateStr + 'T00:00:00');
            if (isNaN(d.getTime())) return dateStr;

            const weekday = new Intl.DateTimeFormat('ru-RU', {weekday: 'short'}).format(d);
            const dayMonth = new Intl.DateTimeFormat('ru-RU', {day: 'numeric', month: 'long'}).format(d);

            return `${dayMonth}, ${weekday}`;
        },

        formatPriceRub(price) {
            const n = Number(price || 0);
            return new Intl.NumberFormat('ru-RU').format(n) + ' ₽';
        },

        renderConfirmation() {
            const root = document.getElementById('recordForm');
            if (!root) return;

            // выбранные сущности
            const doctor = this.doctors.find(x => Number(x.id) === Number(this.selected.user_id));
            const service = this.services.find(x => Number(x.id) === Number(this.selected.service_id));

            const doctorFio = String(doctor?.fio || '—');
            const doctorPhoto = (doctor?.photo || doctor?.avatar)
                ? (window.appConfig.baseUrl + (doctor.photo || doctor.avatar))
                : '/img/plug.jpg';

            const serviceTitle = String(service?.title || '—');
            const duration = Number(this.selected.duration_min || service?.duration_min || 0);

            // дата/время
            const dateText = this.formatDateRu(this.selected.date);
            const timeText = this.selected.time ? String(this.selected.time) : '—';

            // услуга строкой как у тебя в “красивом” примере
            const serviceText = duration
                ? `${serviceTitle} ${duration} минут`
                : serviceTitle;

            const priceText = this.formatPriceRub(this.selected.price);

            // место приёма (если нет поля — оставим "—" или возьми из конфига)
            const addressText = String(this.selected.store_address || this.selected.store_title || '—');

            // подстановка
            const $date = root.querySelector('.js-record-date');
            const $time = root.querySelector('.js-record-time');
            const $service = root.querySelector('.js-record-service');
            const $price = root.querySelector('.js-record-price');
            const $fio = root.querySelector('.js-record-doctor-fio');
            const $photo = root.querySelector('.js-record-doctor-photo');
            const $addr = root.querySelector('.js-record-address');

            if ($date) $date.textContent = ' ' + dateText;
            if ($time) $time.textContent = ' ' + timeText;
            if ($service) $service.textContent = ' ' + serviceText;
            if ($price) $price.textContent = ' ' + priceText;

            if ($fio) $fio.textContent = doctorFio;
            if ($photo) $photo.src = doctorPhoto;
            if ($addr) $addr.textContent = addressText;
        },

        reinitDateSwiper() {
            const root = document.getElementById('recordForm');
            if (!root || !window.Swiper) return;

            const dateEl = root.querySelector('.date-slider');
            if (!dateEl) return;

            // уничтожаем старый
            if (this.dateSwiper) {
                this.dateSwiper.destroy(true, true);
                this.dateSwiper = null;
            }

            const nextEl = root.querySelector('.date-slider-wrap .swiper-button-next');
            const prevEl = root.querySelector('.date-slider-wrap .swiper-button-prev');

            this.dateSwiper = new window.Swiper(dateEl, {
                slidesPerView: 5,
                spaceBetween: 10,
                navigation: {nextEl, prevEl},

                // чтобы не “залипало” при малом числе слайдов/ширине
                watchOverflow: true,
                observer: true,
                observeParents: true,

                breakpoints: {
                    0: {slidesPerView: 1.2},
                    480: {slidesPerView: 2.2},
                    768: {slidesPerView: 3.2},
                    1024: {slidesPerView: 5},
                },
            });
        },

        renderTimesForDate(date) {
            const root = document.getElementById('recordForm');
            const timeWrapper = root?.querySelector('.time-slider .swiper-wrapper');
            if (!timeWrapper) return;

            timeWrapper.innerHTML = '';

            const slots = this.scheduleSlots?.[date] || [];

            const slide = document.createElement('div');
            slide.className = 'swiper-slide';

            const ul = document.createElement('ul');

            for (const t of slots) {
                const li = document.createElement('li');
                li.innerHTML = `
      <label class="noneactive">
        <input type="radio" name="time" value="${t}">
        <div class="radio-name">${t}</div>
      </label>
    `;

                li.querySelector('input').addEventListener('change', () => {
                    this.selected.time = String(t);
                    this.syncButtons();
                });

                ul.appendChild(li);
            }

            slide.appendChild(ul);
            timeWrapper.appendChild(slide);

            this.initSwipers();
            this.timeSwiper?.update();
            this.timeSwiper?.slideTo(0, 0);
        },

        bindNavButtons() {
            const root = document.getElementById('recordForm');
            if (!root) return;

            root.querySelectorAll('.next-state').forEach(btn => {
                btn.addEventListener('click', async () => {
                    if (this.step === 4) {
                        await this.submit();
                        return;
                    }
                    this.setStep(this.step + 1);
                });
            });

            root.querySelectorAll('.prev-state').forEach(btn => {
                btn.addEventListener('click', () => this.setStep(this.step - 1));
            });

            const ln = root.querySelector('#feedback-surname');
            const fn = root.querySelector('#feedback-name');
            const pt = root.querySelector('#feedback-patronymic');
            const bd = root.querySelector('#feedback-date');
            const ph = root.querySelector('#feedback-phone');
            const em = root.querySelector('#feedback-email');
            const agree = root.querySelector('input[name="agree"]');

            const sync = () => {
                this.form.last_name = ln?.value || '';
                this.form.first_name = fn?.value || '';
                this.form.patronymic = pt?.value || '';
                this.form.birthday = bd?.value || '';
                this.form.phone = ph?.value || '';
                this.form.email = em?.value || '';
                this.form.agree = !!agree?.checked;
                this.syncButtons();
            };

            [ln, fn, pt, bd, ph, em].forEach(el => el?.addEventListener('input', sync));
            agree?.addEventListener('change', sync);
        },

        async submit() {
            const start_at = (this.selected.date || '') + ' ' + (this.selected.time || '') + ':00';

            const payload = {
                start_at,
                user_id: this.selected.user_id,
                service_id: this.selected.service_id,
                price: this.selected.price,
                duration_min: this.selected.duration_min,
                store_id: this.selected.store_id,
                surname: this.form.last_name,
                name: this.form.first_name,
                patronymic: this.form.patronymic,
                birthdate: this.form.birthday,
                phone: this.form.phone,
                email: this.form.email,
            };

            const resp = await window.recordPageService.add(payload);

            if (Number(resp?.status || 0) === 200) {
                const doctor = this.doctors.find(x => Number(x.id) === Number(this.selected.user_id));

                const doctorPhoto = (doctor?.photo || doctor?.avatar)
                    ? (window.appConfig.baseUrl + (doctor.photo || doctor.avatar))
                    : '/img/plug.jpg';

                window.globalState.openModal("recordSuccess", {
                    date: this.formatDateRu(this.selected.date),
                    dateRaw: this.selected.date,
                    time: this.selected.time,
                    doctor: doctor?.fio || '',
                    address: this.selected.store_address || this.selected.store_title || '',
                    doctorPhoto: doctorPhoto,
                    duration: this.selected.duration_min
                });
                this.setStep(5);
                return;
            }

            console.error('[RecordPage] add error', resp);
            globalState.addNotification(
                `Ошибка записи. Попробуйте ещё раз или свяжитесь с нами по телефону.`
            );
        },

        initSwipers() {
            const root = document.getElementById('recordForm');
            if (!root) return;

            const dateEl = root.querySelector('.date-slider');
            const timeEl = root.querySelector('.time-slider');

            if (!dateEl || !timeEl) return;

            // Swiper должен быть подключен (window.Swiper)
            if (!window.Swiper) {
                console.error('[RecordPage] Swiper not found. Подключи swiper js/css.');
                return;
            }

            // date swiper
            if (!this.dateSwiper) {
                this.dateSwiper = new window.Swiper(dateEl, {
                    slidesPerView: 5,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: root.querySelector('.date-slider-wrap .swiper-button-next'),
                        prevEl: root.querySelector('.date-slider-wrap .swiper-button-prev'),
                    },
                    breakpoints: {
                        0: {slidesPerView: 1.2},
                        480: {slidesPerView: 2.2},
                        768: {slidesPerView: 3.2},
                        1024: {slidesPerView: 5},
                    },
                });
            }

            // time swiper
            if (!this.timeSwiper) {
                this.timeSwiper = new window.Swiper(timeEl, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    autoHeight: true,
                });
            }
        },

        async mount() {
            this.bindNavButtons();
            this.renderStep();
            this.initSwipers();

            await this.loadProfessions();

            const qs = new URLSearchParams(window.location.search || '')
            const profession_id = Number(qs.get('profession_id') || 0) || 0
            const user_id = Number(qs.get('user_id') || 0) || 0

            if (profession_id > 0 && user_id > 0) {
                this.lockMinStep = 2
                this.selected.profession_id = profession_id
                await this.loadDoctors()
                this.selected.user_id = user_id
                await this.loadDoctorStores()
                await this.loadServices()
                this.setStep(2)
                this.renderServicesList()
                this.syncButtons()
                return
            }

            this.renderProfessionsList();
            this.syncButtons();
        }
    },

    mounted() {
        this.mount();
    },
};

window.RecordPageComponent = RecordPageComponent;